import { defineMessage } from 'services/localization';

export const messages = {
    itemColumnName: defineMessage('item'),
    descriptionColumnName: defineMessage('description'),
    qtyColumnName: defineMessage('qty'),
    unitPriceColumnName: defineMessage('unit_price_1'),
    discountColumnName: defineMessage('disc'),
    discountInvoiceColumnName: defineMessage('disc_2'),
    accountColumnName: defineMessage('account'),
    taxRateColumnName: defineMessage('tax'),
    amountColumnName: defineMessage('amount_currency_2'),
};
